define( function() {
	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/ajax/var/rquery.js
// module id = 855
// module chunks = 0